export const AppNames = {
  REDCAP_PERMS: "redcapperms",
  SCHEDULER: "scheduler",
};

export const AppTitles = {
  REDCAP_PERMS: "REDCap Permissions",
  SCHEDULER: "Seeking Training",
  SCHEDULING_TAB: "Scheduling",
  PERSONAL_TAB: "Profile",
  TRAINER_SCHEDULER: "Trainer Availability",
  SCHEDULER_BYPASS: "Scheduler Submission",
  ADMIN: "Admin",
  PROFILE: "Profile",
  LANGUAGE: "Trainer Language",
  HUB: "Central Hub",
  VOLUNTEERHUB: "Volunteer Hub",
  CHECKLIST: "Training Checklist",
  NEEDTOKNOW: "Need to Know",
  EXISTINGTRAINING: "Existing Events",
  RAINTERVIEW: "RA Interview",
  EXISTINGINTERVIEWS: "Existing RA Interviews",
  DAILYCALLSEXAM: "Daily Calls Exam",
  EXISTINGDAILYCALLSEXAMS: "Existing Daily Calls Exams"
};

export const AppAccess = {
  DEFAULT: "Default",
  ADMIN: "Admin",
};

export const AppActions = {
  redcapPerms: {
    UPDATE_PROJECTS: "Updated projects",
    UPDATE_PROJECT_FORMS: "Updated project forms",
    UPDATE_REDCAP_PERMS: "Updated permissions for UT EIDs on REDCap",
    ADD_PROJECT: "Added project to database",
    DELETE_PROJECT: "Deleted project from database",
    ADD_PERM_SET: "Added permission set to database",
    DELETE_PERM_SET: "Deleted permission set from database",
    UPDATE_PERM_SETS: "Updated permission sets",
  },
  scheduler: {
    UPLOAD_AVAILABILITY: "uploaded availability",
    SCHEDULED: "scheduled",
    CONFIRMED: "confirmed event",
  },
};

export const AdminAccess = {
  DEFAULT: "N/A",
  ADMIN: "Admin",
};


// The exams an RA can be scheduled for on the daily calls side. The emails put
// this text straight into their subject and body, so this is the wording RAs
// and exam administrators see.
export const DailyCallsExamTypes = [
  "Intro meeting",
  "10 am survey",
  "10 am brain games",
  "10:15 am",
  "6 pm",
  "8:30 pm",
  "10 pm",
];

export const LangOptions = {
  ENGL: "English",
  SPAN: "Spanish",
};